class InvalidBaseURL extends Error {
    constructor(hostname, options) {
        super(`Invalid HTTPClient base URL '${hostname}'`, options);
    }
}
export default InvalidBaseURL;
